export const LABELS = {
  NO_MIN: "No Min",
  NO_MAX: "No Max",
};

export const PROPERTY_BUILT_RANGE = {
  MIN: 1900,
  // The current year, not a literal: the search sends maxYearBuilt whenever the
  // max is below it, so a stale year would quietly drop new construction.
  MAX: new Date().getFullYear(),
};
